import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';

@Component({
  selector: 'app-modal-delegar-risco-chave',
  templateUrl: './modal-delegar-risco-chave.component.html',
  styleUrls: ['./modal-delegar-risco-chave.component.scss']
})
export class ModalDelegarRiscoChaveComponent implements OnInit {

  questionarioId: any;

  model: any;
  idResponsavel;
  riscoChaveId;

  constructor(
    private dialogRef: MatDialogRef<ModalDelegarRiscoChaveComponent>,
    private riscosChavesService: RiscosChavesServices,
    public router: Router,
    public toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.model = data.dados;
    this.questionarioId = data.questionarioId;
    this.riscoChaveId = data.riscoChaveId;
  }


  ngOnInit(): void {
  }

  cancelar() {
    this.dialogRef.close(false);
  }

  async delegar() {
    this.riscosChavesService
      .DelegarQuestionario(this.questionarioId, this.idResponsavel, this.riscoChaveId)
      .then((res) => {
        this.dialogRef.close(true);
      }
      )
  }

}
